import axios from 'axios';

const baseURL = `api/blindstockmultiplex`;

export default {
    getBlindstockMultiplexCharacteristics() {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(baseURL);
    },
};